class LinkedVariants extends HTMLElement {
  constructor() {
    super();
    this.currentHandle = this.dataset.currentHandle;
    this.carouselContainer = this.querySelector('[data-linked-variants-list]');
  }

  connectedCallback() {


    const jsonScript = this.querySelector('script[data-linked-variants-json]');
    if (!jsonScript || !this.carouselContainer) {
      this.renderError('Linked variants data missing.');
      return;
    }

    let products;
    try {
      products = JSON.parse(jsonScript.textContent);
    } catch (e) {
      this.renderError('Failed to parse linked variants data.');
      return;
    }

    this.renderVariants(products);
  }

  renderVariants(products) {
    if (!products.length || products.length <= 1) {
      this.carouselContainer.innerHTML = '';
      window.__linkedVariantsVisible = false;
      window.dispatchEvent(new CustomEvent('linked-variants:visibility', {
        detail: {
          hasVisibleVariants: false,
        },
      }));
      return;
    }

    this.classList.remove('d-none');

    const currentProduct = products.find(p => p.handle === this.currentHandle);
    const currentValues = {};
    const preferredOptionOrder = [];
    for (const opt of (currentProduct?.options || [])) {
      currentValues[opt.name] = opt.value;
      preferredOptionOrder.push(opt.name);
    }

    const optionGroups = {};
    for (const product of products) {
      for (const option of (product.options || [])) {
        if (!optionGroups[option.name]) optionGroups[option.name] = [];

        const existing = optionGroups[option.name].find(item => item.value === option.value);
        if (!existing) {
          optionGroups[option.name].push({ value: option.value, handle: product.handle });
        } else {
          const score = (p) => p.options.filter(
            o => o.name !== option.name && currentValues[o.name] === o.value
          ).length;
          const existingProduct = products.find(p => p.handle === existing.handle);
          if (score(product) > score(existingProduct)) {
            existing.handle = product.handle;
          }
        }
      }
    }

    const optionNames = Object.keys(optionGroups);
    const orderedOptionNames = [
      ...preferredOptionOrder.filter(name => optionGroups[name]),
      ...optionNames.filter(name => !preferredOptionOrder.includes(name)),
    ];

    const orderedOptionEntries = orderedOptionNames.map((name) => [name, optionGroups[name]]);

    for (const [optionName, items] of Object.entries(optionGroups)) {
      if (optionName === orderedOptionNames[0]) continue;
      for (const item of items) {
        item.unavailable = !products.some(p =>
          p.options.some(o => o.name === optionName && o.value === item.value) &&
          Object.entries(currentValues)
            .filter(([name]) => name !== optionName)
            .every(([name, val]) => p.options.some(o => o.name === name && o.value === val))
        );
      }
    }

    console.log('Option Groups:', optionGroups);

    const totalItems = Object.values(optionGroups).reduce((sum, items) => sum + items.length, 0);
    let globalIndex = 0;
    let html = '';
    let oneActiveVar = false;

    for (const [optionName, items] of orderedOptionEntries) {
      const itemsHtml = items.map(({ value, handle, unavailable }) => {
        const url = `/products/${handle}`;
        const isActive = currentValues[optionName] === value;
        const idx = globalIndex++;
        const isToggleable = totalItems > 5 && idx > 5;

        if (isActive) {
          oneActiveVar = true;
        }

        const classes = [
          'linked-variants__item',
          isActive ? 'active' : '',
          unavailable ? 'unavailable' : '',
          isToggleable ? 'hidden' : '',
        ].filter(Boolean).join(' ');

        return `<a href="${url}" class="${classes}" role="button"${isToggleable ? ' data-toggleable-item' : ''}>${value}</a>`;
      }).join('');

      html += `
        <div class="linked-variants__group">
          <div class="linked-variants__group-label">${optionName}</div>
          <div class="linked-variants__items">${itemsHtml}</div>
        </div>
      `;
    }

    if (!oneActiveVar) {
      this.classList.add('d-none');
    }

    window.__linkedVariantsVisible = oneActiveVar;
    window.dispatchEvent(new CustomEvent('linked-variants:visibility', {
      detail: {
        hasVisibleVariants: oneActiveVar,
      },
    }));

    this.carouselContainer.innerHTML = html;

    const toggleText = {
      collapsed: this.carouselContainer.dataset.toggleCollapsedText,
      expanded: this.carouselContainer.dataset.toggleExpandedText,
    };

    // if (totalItems > 5) {
    //   this.carouselContainer.innerHTML += `<div class="show-more-wrap" style="width: 100%;">
    //     <a href="javascript:;" class="variants-toggle" data-toggle-more>
    //       <span data-toggle-text>${toggleText.collapsed}</span>
    //       <i class="icon-chevron--down"></i>
    //     </a>
    //   </div>`;

    //   const toggleableItems = this.querySelectorAll('[data-toggleable-item]');
    //   this.querySelector('[data-toggle-more]')?.addEventListener('click', () => {
    //     const toggleStatus = this.carouselContainer.getAttribute('data-toggle-status');
    //     const text = this.querySelector('[data-toggle-text]');
    //     text.innerText = toggleText[toggleStatus === 'collapsed' ? 'expanded' : 'collapsed'];
    //     this.carouselContainer.setAttribute('data-toggle-status', toggleStatus === 'collapsed' ? 'expanded' : 'collapsed');
    //     toggleableItems.forEach(item => item.classList.toggle('hidden'));
    //   });
    // }
  }

  renderError(message) {
    const errorElement = document.createElement('p');
    errorElement.className = 'color__variants--error';
    errorElement.textContent = message;
    this.appendChild(errorElement);
  }
}

customElements.define('linked-variants', LinkedVariants);
